import(/* webpackMode: "eager", webpackExports: ["BlogPostView"] */ "/app/src/components/content/BlogPostView.tsx");
